import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 5l-10 14","key":"svg-0"}],["path",{"d":"M20 5l-10 14","key":"svg-1"}]]

const IconSlashes = createReactComponent('outline', 'slashes', 'Slashes', __iconNode);

export default IconSlashes;